<template>
  <div class="serachNav">
    <div style="margin: 0 auto;display: inline-block;">
      <div><h1>海量GMAT题库 · 做题搜题一网打尽</h1></div>
      <div class="titTag" style="display: flex;justify-content: space-between;">
        <a class="scoreTag">题库总题数9k+</a>
        <a>模考仿真度99%</a>
        <a class="scoreLast">题库更新频率Day By Day</a>
      </div>
    </div>
    <div class="searchInput">
      <input placeholder="搜索包括不限于以下题源：OG PREP破解版（07/08/12） GWD OG分册 Advanced 300 ……等市面全部主流题源" @click="goSearch"/>
    </div>
    <div class="searchText">题源会配备真人视频逐题讲解哦，做GMAT，我们是用心的</div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
      }
    },
    methods:{
      goSearch(){
        this.$router.push("/searchMatter")
      }
    }
  }
</script>
<style scoped>
  .serachNav {
    width: 100%;
    height: 529px;
    background: url(../assets/home/serchbg.png) no-repeat;
    min-width: 1200px;
    text-align: center;
    background-size: cover;
  }

  .serachNav h1 {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    opacity: 1;
    padding-top: 114px;
  }

  .titTag {
    margin: 35px auto 35px auto;
    font-size: 16px;
    color: #8F8F8F;
  }

 .scoreTag {
    margin-right: 130px;
  }

  .scoreLast {
    margin-left: 130px;
  }

  .searchInput {
    font-size: 18px;
  }

  .searchInput input {
    width: 919px;
    height: 60px;
    opacity: 1;
    border-radius: 39px;
    border: none;
    outline: none;
    font-size: 16px;
    padding-left: 45px;
    color: #999999;
    background: #FFFFFF;
    box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.07);
    opacity: 1;
    border-radius: 39px;
    background-position: 95%;
  }

  .searchText {
    height: 27px;
    font-size: 16px;
    font-weight: 400;
    line-height: 27px;
    color: #8F8F8F;
    opacity: 1;
    margin-top: 33px;
  }
  
  input::-webkit-input-placeholder{
          
          color: #999999;
          opacity: 0.39;
       }
        input::-moz-placeholder{   /* Mozilla Firefox 19+ */
           
           color: #999999;
           opacity: 0.39;
       }　　
        input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
           
           color: #999999;
           opacity: 0.39;
       }
       input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
          
          color: #999999;
          opacity: 0.39;
      }
</style>



// WEBPACK FOOTER //
// src/components/searchNav.vue